import React, { useState } from 'react';
import {Link} from "react-router-dom";
import url from "../utils/UrlHelper";
import {useAppSelector} from "../redux/hooks";

function ChangelogPage() {
    const {sellerId} = useAppSelector(({sellers}) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }));

    const data = [

        {
            date: '15 Декабря, 2022',
            title: 'Исправлены ошибки',
            type: 'bug',
            text: '- Исправлена автогенерация YML фидов для Яндекса.' +
                '- Исправлена сортировка для таблицы Продуктов',
        },
        {
            date: '14 Декабря, 2022',
            title: 'Генерация Штрихкодов',
            type: 'улучшение',
            text: 'Вышел новый генератор ШК. Где можно распечатать Этикеты с их атрибутами.',
        },
        {
            date: '9 Декабря, 2022',
            title: 'Работа над оптимизацией сайта',
            type: 'улучшение',
            text: 'Уменьшен интервал загрузки заказов.' +
                'Были оптимизированы разделы Продуктов и Заказов',
        },
    ]

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-white">

                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

                        {/* Page header */}
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">
                            {/* Left: Title */}
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">Changelog ✨</h1>
                            </div>
                        </div>

                        <div className="border-t border-gray-200">
                            <div className="max-w-3xl m-auto mt-8">
                                {/* Posts */}
                                <div className="xl:-translate-x-16">
                                    {/* Post */}
                                    <article className="pt-6">
                                        <div className="xl:flex">
                                            <div className="w-32 flex-shrink-0">
                                                <div className="text-xs font-semibold uppercase text-gray-400 xl:leading-8">30 Ноября, 2022</div>
                                            </div>
                                            <div className="flex-grow pb-6 border-b border-gray-200">
                                                <header>
                                                    <h2 className="text-2xl text-gray-800 font-bold mb-3">Штрихкоды</h2>
                                                    <div className="flex flex-nowrap items-center space-x-2 mb-4">
                                                        <div className="flex items-center">
                                                            <a className="block text-sm font-semibold text-gray-800" href="#0">Администратор</a>
                                                        </div>
                                                        <div className="text-gray-400">·</div>
                                                        <div>
                                                            <Link to={url('/:sellerId/tools', sellerId)} className="text-xs inline-flex font-medium bg-green-100 text-green-600 rounded-full text-center px-2.5 py-1">Инструменты</Link>
                                                        </div>
                                                    </div>
                                                </header>
                                                <div className="space-y-3">
                                                    <p>Мы улучшили функционал по генерации <Link to={url('/:sellerId/tools/barcode', sellerId)} className="font-medium text-blue hover:text-blue/80">штрихкодов</Link>, где Вы теперь можете скачать штрихкоды в виде pdf файлов.</p>
                                                    <p>Доступны разные размеры этикеток 43х25, 58х40. </p>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                    {/* Post */}
                                    <article className="pt-6">
                                        <div className="xl:flex">
                                            <div className="w-32 flex-shrink-0">
                                                <div className="text-xs font-semibold uppercase text-gray-400 xl:leading-8">16 Ноября, 2022</div>
                                            </div>
                                            <div className="flex-grow pb-6 border-b border-gray-200">
                                                <header>
                                                    <h2 className="text-2xl text-gray-800 font-bold mb-3">Выущена 1 версия плагина по интеграции с 1С 🎉</h2>
                                                    <div className="flex flex-nowrap items-center space-x-2 mb-4">
                                                        <div className="flex items-center">
                                                            <a className="block text-sm font-semibold text-gray-800" href="#0">Администратор</a>
                                                        </div>
                                                        <div className="text-gray-400">·</div>
                                                        <div>
                                                            <div className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">1С интеграция</div>
                                                        </div>
                                                    </div>
                                                </header>
                                                <div className="space-y-3">
                                                    <p>Предоставляем Вашему вниманию стабильную версию 1С плагина для интеграции конфигурации УТ 11.4 и 11.5 с LK.MARKET</p>
                                                </div>
                                            </div>
                                        </div>
                                    </article>

                                    {/* Post */}
                                    <article className="pt-6">
                                        <div className="xl:flex">
                                            <div className="w-32 flex-shrink-0">
                                                <div className="text-xs font-semibold uppercase text-gray-400 xl:leading-8">4 Октября, 2022</div>
                                            </div>
                                            <div className="flex-grow pb-6 border-b border-gray-200">
                                                <header>
                                                    <h2 className="text-2xl text-gray-800 font-bold mb-3">Исправление багов</h2>
                                                    <div className="flex flex-nowrap items-center space-x-2 mb-4">
                                                        <div className="flex items-center">
                                                            <a className="block text-sm font-semibold text-gray-800" href="#0">Команда разработчиков</a>
                                                        </div>
                                                        <div className="text-gray-400">·</div>
                                                        <div>
                                                            <div className="text-xs inline-flex font-medium bg-red-100 text-red-600 rounded-full text-center px-2.5 py-1">Bug Fix</div>
                                                        </div>
                                                    </div>
                                                </header>
                                                <div className="space-y-3">
                                                    <p>Были исправлены следующие проблемы:</p>
                                                    <ul className="list-disc list-inside space-y-1">
                                                        <li>WB: исправлен баг при отправке поля "Названия" продукта;</li>
                                                        <li>Автогенерация YML: Исправлены остатки для СберМегеМаркета;</li>
                                                        <li>WB: исправлена валидация токена;</li>
                                                        <li>Подчищены категории МП с неверными наименованиями;</li>
                                                        <li>Исправлены статусы Заказов;</li>
                                                        <li>Исправлена выгрузка exel шаблонов для Яндекса;</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                    {/* Post */}
                                    <article className="pt-6">
                                        <div className="xl:flex">
                                            <div className="w-32 flex-shrink-0">
                                                <div className="text-xs font-semibold uppercase text-gray-400 xl:leading-8">2 July, 2021</div>
                                            </div>
                                            <div className="flex-grow pb-6 border-b border-gray-200">
                                                <header>
                                                    <h2 className="text-2xl text-gray-800 font-bold mb-3">Thanks, everyone 🙌</h2>
                                                    <div className="flex flex-nowrap items-center space-x-2 mb-4">
                                                        <div className="flex items-center">

                                                            <a className="block text-sm font-semibold text-gray-800" href="#0">
                                                                Danielle Cohen
                                                            </a>
                                                        </div>
                                                        <div className="text-gray-400">·</div>
                                                        <div>
                                                            <div className="text-xs inline-flex font-medium bg-light-blue-100 text-light-blue-600 rounded-full text-center px-2.5 py-1">Exciting News</div>
                                                        </div>
                                                    </div>
                                                </header>
                                                <div className="space-y-3">
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur excepteur sint occaecat cupidatat non proident.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>

                            </div>
                        </div>

                    </div>
                </main>
            </div>
        </div>
    );
}

export default ChangelogPage;
